module.exports = __webpack_public_path__ + "static/media/Trade Hub Diagram - GBR Tech - 26-09-2024 C.d455244b.png";